import { tv } from 'tailwind-variants'

export const bodyLayoutVariants = tv({
  slots: {
    container: 'flex flex-col items-stretch m-auto w-full'
  }
})
